import { render, staticRenderFns } from "./dynamicList.vue?vue&type=template&id=f0a83750&scoped=true&"
import script from "./dynamicList.vue?vue&type=script&lang=js&"
export * from "./dynamicList.vue?vue&type=script&lang=js&"
import style0 from "./dynamicList.vue?vue&type=style&index=0&id=f0a83750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a83750",
  null
  
)

export default component.exports